import { render, staticRenderFns } from "./AlgoliaToggleFacet.vue?vue&type=template&id=680a1834"
import script from "./AlgoliaToggleFacet.vue?vue&type=script&lang=js"
export * from "./AlgoliaToggleFacet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports